import { useCallback, useMemo } from 'react'
import { arrayToMap } from 'lib/array/arrayUtils'
import type { TripItineraryData } from 'tripPlanner/api/types'
import type { SendMessageOptions } from 'tripPlanner/components/AddToTrip/useAddHotelToTrip'
import type { ExploreItem } from 'tripPlanner/types/common'
import type { ChatExploreCategoryKey } from 'tripPlanner/config/exploreCategories'
import type { GeoPoint } from 'tripPlanner/types/placeAndDateTime'
import DrawerListingMapPreview, { type DrawerListingMapItem } from '../DrawerListingMapPreview'

interface Props {
  categoryKey: ChatExploreCategoryKey
  places: Array<ExploreItem>
  coordinates: GeoPoint
  onSelectPlace: (place: ExploreItem) => void
  onViewOnMap: () => void
  itineraryData?: TripItineraryData
  onSendMessage?: (message: string, options?: SendMessageOptions) => void
}

function ThingsToDoMapPreview({
  categoryKey,
  places,
  coordinates,
  onSelectPlace,
  onViewOnMap,
  itineraryData,
  onSendMessage,
}: Props) {
  const placesById = useMemo(() => arrayToMap(places, place => place.id), [places])
  const items = useMemo<Array<DrawerListingMapItem>>(() => places.map(place => ({
    id: place.id,
    name: place.name,
    coordinates: place.place.point,
    kind: 'place',
    categoryKey,
  })), [categoryKey, places])
  const handleSelectItem = useCallback((id: string) => {
    const place = placesById.get(id)
    if (place) onSelectPlace(place)
  }, [onSelectPlace, placesById])

  return (
    <DrawerListingMapPreview
      items={items}
      coordinates={coordinates}
      onSelectItem={handleSelectItem}
      onViewOnMap={onViewOnMap}
      itineraryData={itineraryData}
      onSendMessage={onSendMessage}
    />
  )
}

export default ThingsToDoMapPreview
